module.exports = __webpack_public_path__ + "static/media/add-ticket-type.928fc2c8.png";